import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IArrowUpToolButtonProps extends IconButtonProps {
    tooltip?: string;
}

export const ArrowUpToolButton = (props: IArrowUpToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.MoveUp}
        icon={<ArrowUpwardIcon />}
    />
);
